package team.platforma.auth_presentable.di

import org.koin.compose.viewmodel.dsl.viewModelOf
import org.koin.dsl.module
import team.platforma.auth_presentable.viewModel.AuthViewModel
import team.platforma.auth_presentable.viewModel.ConfirmEmailViewModel
import team.platforma.auth_presentable.viewModel.RegistrationViewModel

val authPresentationModule = module {
    single { AuthViewModel(get()) }
    viewModelOf(::AuthViewModel)
    single { ConfirmEmailViewModel() }
    single { RegistrationViewModel() }
}